<template>
<div class="edit-delivery">

  <vue-headful
    title="TZ Design Box - Edit delivery"
    description="TZ Design Box"
/>

  <div class="container">
    <div class="columns">
      <div class="column is-2 menu-vert">
        <MenuVert :currentactive="'overview-deliverys'" />
      </div>
      <div class="column is-10" style="margin-top:25px;">
        <Breadcrumbs/>
        <hr>
        <div class="content">
          <h2>{{ $t("delivery-edit") }} </h2>
          <p>{{ $t("delivery-edit-details") }} </p>
          <form @submit.prevent="validateBeforeSubmit">
            <b-field grouped>
              <b-field expanded :label="$t('name1')"
                :type="{'is-danger': errors.has('name1')}"
                :message="errors.first('name1')">
                <b-input v-model="getDeliveryEdit.name1" name="name1" v-validate="'required'" />
              </b-field>
              <b-field expanded :label="$t('name2')"
                :type="{'is-danger': errors.has('name2')}"
                :message="errors.first('name2')">
                <b-input v-model="getDeliveryEdit.name2" name="Name2" />
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field expanded :label="$t('address1')">
                <b-input v-model="getDeliveryEdit.address1" name="address1" disabled />
              </b-field>
              <b-field expanded :label="$t('address2')">
                <b-input v-model="getDeliveryEdit.address2" name="address2" disabled />
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field expanded :label="$t('zip')">
                <b-input v-model="getDeliveryEdit.zip" name="zip" disabled />
              </b-field>
              <b-field expanded :label="$t('city')">
                <b-input v-model="getDeliveryEdit.city" name="city" disabled />
              </b-field>
              <b-field expanded :label="$t('country')">
                <b-select name="country" v-model="getDeliveryEdit.country" disabled>
                  <option v-for="country in getCountryCodesAdress"
                          :value="country[0]"
                          :key="country[0]">
                          {{ country[1] }}
                      </option>
                </b-select>
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field expanded :label="$t('phone')"
                :type="{'is-danger': errors.has('phone')}"
                :message="errors.first('phone')">
                <b-input v-model="getDeliveryEdit.phone" name="phone" v-validate="'required'" />
              </b-field>
              <b-field expanded :label="$t('mobilephone')"
                :type="{'is-danger': errors.has('mobile')}"
                :message="errors.first('mobile')">
                <b-input v-model="getDeliveryEdit.mobile" name="mobile" />
              </b-field>
              <b-field :label="$t('email')"
                :type="{'is-danger': errors.has('email')}"
                :message="errors.first('email')">
                <b-input v-model="getDeliveryEdit.email" name="email" v-validate="'email'"  />
              </b-field>
            </b-field>

            <b-button native-type="submit" type="is-primary" :loading="saveDeliveryActive">{{ $t("save") }}</b-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MenuVert         from '@/components/MenuVert'
import Breadcrumbs      from '@/components/Breadcrumbs'
import { mapGetters }   from 'vuex'

export default {
    name:'Editdelivery',
    props: ['address','redirect'],
    computed: {
    ...mapGetters ([
        "getCurrentCompany",
        "getCompany",
        "getDeliveryEdit",
        "saveDeliveryActive",
        "getCountryCodesAdress"]),
        cid: {
            get () { return this.getCompany}
        },
    },
    data: function(){
        return{
            delivery: {},
        }
    },
    components: { MenuVert, Breadcrumbs},
    methods: {
        validateBeforeSubmit() {
            var self=this
            this.$validator.validateAll ().then ((result) => {
                if (result) {
                    this.$store.dispatch (
                        "saveEditdelivery",{
                            self: self,address:this.address,cid:this.cid}
                    )
                    .catch((error) =>{
                        self.$toastr('error', error, 'Failure')
                    })
                    return
                }
            })
        },
        update () {
            const self = this
            let  cid   = this.getCompany
            this.$store.dispatch ("callCurrentCompany",  {self: self, company: cid})
            this.$store.dispatch ("callDeliveryEdit",    {self: self, company: cid, address:  this.address})
            this.$store.dispatch ("callDeliveryAdresses",{self: self, company: cid, redirect: this.redirect})
        }
    },
    beforeRouteUpdate (to, from, next) {
        this.update()
        next ()
    },
    mounted () {
        this.update()
    }
}
</script>

<style>
.edit-delivery{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
</style>
